import AffectedCasesBarChart from './AffectedCasesBarChart';
export default AffectedCasesBarChart;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/AffectedCasesBarChart/index.js